import { BuiltinVariableRegistry } from "./builtin/BuiltinVariableRegistry.js";

export interface IfcExpressionOptions {
  builtinVariableRegistry?: BuiltinVariableRegistry;
}
